module.exports = __webpack_public_path__ + "img/plan_bg.9af5b4eb.jpg";